import { ObjectSchema, object, string, number } from 'yup';
import { locale } from './../yup-locale';
import * as yup from 'yup';
import { FcuUnit } from './../../models/fcu-unit';
yup.setLocale(locale);

export const fcuUnitLocationLenLimit = 16;

export function fcuUnitValidator(): ObjectSchema<FcuUnit> {
    return object({
        id: string().uuid().strict(),
        vesselId: string().uuid().strict(),
        index: number().required().nonNullable().strict(),
        location: string().nullable().strict().max(fcuUnitLocationLenLimit),
    })
        .strict()
        .noUnknown();
}
